import React, { useState, useRef } from "react";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import FeaturedDresses from "./components/FeaturedDresses";
import DressTypes from "./components/DressTypes";
import Occasions from "./components/Occasions";
import DressCatalog from "./components/DressCatalog";
import HowItWorks from "./components/HowItWorks";
import AppointmentSection from "./components/AppointmentSection";
import Locations from "./components/Locations";
import InstagramSection from "./components/InstagramSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import CitySelectionModal from "./components/CitySelectionModal";
import Accessories from "./components/Accessories";
import ConsultationCart from "./components/ConsultationCart";
import { CartProvider } from "./context/CartContext";
import { bookingLink } from "./data/mockData";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [modalContext, setModalContext] = useState('booking');
  const catalogRef = useRef(null);

  const handleBookingClick = () => {
    // Main "Agenda tu cita" CTA opens the Linktree booking link, not WhatsApp.
    window.open(bookingLink, '_blank', 'noopener,noreferrer');
  };

  const handleDressInquiry = (dressName) => {
    setModalContext(`dress-${dressName}`);
    setIsCityModalOpen(true);
  };

  const handleCitySelect = () => {
    setModalContext('booking');
    setIsCityModalOpen(true);
  };

  const handleViewDresses = () => {
    const element = document.getElementById('catalog');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleOccasionSelect = (occasionName) => {
    // Activate the filter in catalog
    if (catalogRef.current) {
      catalogRef.current.filterByOccasion(occasionName);
    }
    // Scroll to catalog after a tiny delay so state updates first
    setTimeout(() => {
      const element = document.getElementById('catalog');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50);
  };

  return (
    <CartProvider>
      <div className="App">
        <Header onBookingClick={handleBookingClick} />
        <HeroSection
          onBookingClick={handleBookingClick}
          onViewDressesClick={handleViewDresses}
        />
        <DressTypes />
        <FeaturedDresses onDressInquiry={handleDressInquiry} />
        <Occasions onOccasionSelect={handleOccasionSelect} />
        <DressCatalog ref={catalogRef} onDressInquiry={handleDressInquiry} />
        <Accessories />
        <HowItWorks />
        <AppointmentSection onCitySelect={handleCitySelect} />
        <Locations onCitySelect={handleCitySelect} />
        <InstagramSection />
        <FAQSection />
        <Footer />

        <CitySelectionModal
          isOpen={isCityModalOpen}
          onClose={() => setIsCityModalOpen(false)}
          onSelectCity={handleCitySelect}
          context={modalContext}
        />

        <ConsultationCart />
        <Toaster />
      </div>
    </CartProvider>
  );
}

export default App;
